import { api } from '../../client';

export interface LeaveCreditDto {
  id: string;
  type: 'trainee' | 'regular' | 'supervisor' | 'manager';
  credit_name: string;
  days: number;
  created_at?: string;
  updated_at?: string;
}

export const hrLeaveCreditsApi = {
  async list(): Promise<{ data?: LeaveCreditDto[]; message?: string }> {
    return api.get('/hr/leave-credits') as Promise<{ data: LeaveCreditDto[] }>;
  },

  async create(data: {
    type: LeaveCreditDto['type'];
    credit_name: string;
    days: number;
  }): Promise<{ data?: LeaveCreditDto; message?: string; errors?: Record<string, string[]> }> {
    return api.post('/hr/leave-credits', data) as Promise<{
      data: LeaveCreditDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },

  async update(
    id: string,
    data: Partial<{
      type: LeaveCreditDto['type'];
      credit_name: string;
      days: number;
    }>,
  ): Promise<{ data?: LeaveCreditDto; message?: string; errors?: Record<string, string[]> }> {
    return api.put(`/hr/leave-credits/${id}`, data) as Promise<{
      data: LeaveCreditDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },

  async delete(id: string): Promise<{ success?: boolean; message?: string }> {
    return api.delete(`/hr/leave-credits/${id}`) as Promise<{ success?: boolean; message?: string }>;
  },
};
